import React from 'react'
import { Outlet } from 'react-router-dom'
import { TopBar } from './TopBar'
import { Sidebar } from './Sidebar'
import { RightPanel } from './RightPanel'
import { TeamsShell } from './TeamsShell'
import { CopilotChat } from '@/components/copilot/CopilotChat'
import { useHostContext } from '@/contexts/HostContext'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import './AppLayout.css'

function useRelativeLabel(sinceMs: number | null): string {
  const [, setTick] = React.useState(0)
  React.useEffect(() => {
    const id = window.setInterval(() => setTick((v) => v + 1), 30_000)
    return () => window.clearInterval(id)
  }, [])
  if (sinceMs === null) return '—'
  const minutes = Math.max(0, Math.round((Date.now() - sinceMs) / 60_000))
  if (minutes < 1) return 'hace un momento'
  if (minutes === 1) return 'hace 1 min'
  return `hace ${minutes} min`
}

export const AppLayout: React.FC = () => {
  const { host } = useHostContext()
  const currentUser = useCurrentUser()
  const [copilotOpen, setCopilotOpen] = React.useState(false)

  // Marca el momento de la última lectura exitosa de /api/me (proxy simple de
  // "la app volvió a leer Microsoft/SharePoint"), sin tocar auth ni integración.
  const lastReadAtRef = React.useRef<number | null>(null)
  if (currentUser.status === 'authenticated' && lastReadAtRef.current === null) {
    lastReadAtRef.current = Date.now()
  }
  const lastReadLabel = useRelativeLabel(lastReadAtRef.current)

  if (host === 'teams') return <TeamsShell />

  return (
    <div className="appLayout">
      <TopBar copilotOpen={copilotOpen} onToggleCopilot={() => setCopilotOpen((v) => !v)} />
      <Sidebar />
      <div className="appLayout__main">
        <div className="appLayout__content">
          <div className="appLayout__breadcrumb">
            Relaciones, contexto y próximas acciones sobre Microsoft 365
          </div>
          <div className="appLayout__page">
            <Outlet />
          </div>
        </div>
        <RightPanel isOpen={copilotOpen} title="Copilot Sales" onClose={() => setCopilotOpen(false)}>
          <CopilotChat />
        </RightPanel>
      </div>
      <div className="appLayout__statusbar">
        {currentUser.status === 'authenticated'
          ? `Microsoft conectado · SharePoint activo · Última lectura: ${lastReadLabel}`
          : 'Microsoft 365 conectado vía API · SharePoint Lists y Graph gobernados por backend'}
      </div>
    </div>
  )
}
